(function () {
  'use strict';

  var PROPERTY_AUTO_GIFT = '_pp_auto_gift';
  var PROPERTY_RULE = '_pp_gift_rule';
  var PROPERTY_LABEL = '_pp_gift_label';
  var config = window.PPGiftRules || {};
  var scheduledTimer = null;
  var syncing = false;
  var queuedReason = '';

  if (!config.enabled) return;

  function endpoint(routeName, fallback) {
    var route = window.routes && window.routes[routeName] ? window.routes[routeName] : fallback;
    if (route.indexOf('.js') >= 0) return route;
    return route + '.js';
  }

  var endpoints = {
    cart: endpoint('cart_url', '/cart'),
    add: endpoint('cart_add_url', '/cart/add'),
    change: endpoint('cart_change_url', '/cart/change'),
  };

  function diagnose(severity, message, details) {
    window.dispatchEvent(
      new CustomEvent('pp:cart-diagnostic', {
        detail: {
          severity: severity || 'info',
          message: message,
          sourceFile: 'assets/pp-cart-gifts.js',
          sourceComponent: 'PPGiftRules',
          details: details || {},
        },
      })
    );
  }

  function log() {
    if (!config.debug || !window.console || !console.log) return;
    console.log.apply(console, ['[PPGiftRules]'].concat(Array.prototype.slice.call(arguments)));
  }

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function readProperty(properties, name) {
    if (!properties) return '';
    if (Array.isArray(properties)) {
      for (var i = 0; i < properties.length; i += 1) {
        if (properties[i] && properties[i].name === name) return properties[i].value;
      }
      return '';
    }
    return properties[name] || '';
  }

  function isAutoGift(item) {
    return String(readProperty(item.properties, PROPERTY_AUTO_GIFT)).toLowerCase() === 'true';
  }

  function itemVariantId(item) {
    return Number(item.variant_id || item.id || 0);
  }

  function normalizeRules() {
    return (config.rules || []).filter(function (rule) {
      return rule && rule.active !== false;
    });
  }

  function subtotalWithoutAutoGifts(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isAutoGift(item)) return sum;
      return sum + toNumber(item.final_line_price, 0);
    }, 0);
  }

  function eligibleRules(subtotalCents) {
    return normalizeRules().filter(function (rule) {
      var min = toNumber(rule.minSubtotalCents, 0);
      var max = rule.maxSubtotalCents == null ? null : toNumber(rule.maxSubtotalCents, null);
      return subtotalCents >= min && (max == null || subtotalCents <= max);
    });
  }

  function wantedGifts(rules) {
    var wanted = {};

    rules.forEach(function (rule) {
      (rule.gifts || []).forEach(function (gift) {
        var variantId = toNumber(gift.variantId, 0);
        var quantity = Math.max(1, toNumber(gift.quantity, 1));

        if (!variantId) {
          diagnose('warning', 'Regra de brinde ignorada porque o variantId nao foi configurado.', {
            ruleId: rule.id || '',
            ruleName: rule.name || '',
            giftLabel: gift.label || '',
            howToFix: 'Abra snippets/pp-cart-gifts-config.liquid e coloque o ID da variante do brinde.',
          });
          return;
        }

        wanted[variantId] = {
          variantId: variantId,
          quantity: quantity,
          ruleId: rule.id || '',
          ruleName: rule.name || '',
          label: gift.label || 'Brinde automatico',
        };
      });
    });

    return wanted;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data = null;

        try {
          data = text ? JSON.parse(text) : {};
        } catch (error) {
          diagnose('error', 'A resposta do carrinho nao veio em JSON.', {
            url: url,
            status: response.status,
            responsePreview: text ? text.slice(0, 600) : '',
            likelyCause: 'Algum bloqueio, app ou protecao devolveu HTML no lugar de JSON.',
          });
          throw error;
        }

        if (!response.ok) {
          diagnose(response.status >= 500 ? 'critical' : 'error', 'Shopify recusou uma operacao de brinde.', {
            url: url,
            status: response.status,
            response: data,
          });
          var err = new Error('Cart gift request failed: ' + response.status);
          err.response = data;
          throw err;
        }

        return data;
      });
    });
  }

  function getCart() {
    return fetchJson(endpoints.cart, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
  }

  function addGift(gift) {
    log('add gift', gift);
    return fetchJson(endpoints.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: gift.variantId,
            quantity: gift.quantity,
            properties: {
              _pp_auto_gift: 'true',
              _pp_gift_rule: gift.ruleId,
              _pp_gift_label: gift.label,
            },
          },
        ],
      }),
    });
  }

  function changeGift(item, quantity) {
    log('change gift', item.key, quantity);
    return fetchJson(endpoints.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: item.key,
        quantity: quantity,
      }),
    });
  }

  function refreshCartUi(cart) {
    document.dispatchEvent(
      new CustomEvent('pp:gifts-updated', {
        detail: { cart: cart },
      })
    );

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'pp-cart-gifts',
        cartData: cart,
      });
    }
  }

  function syncGifts(reason) {
    if (syncing) {
      queuedReason = reason || 'queued';
      return;
    }

    syncing = true;

    getCart()
      .then(function (cart) {
        var subtotalCents = subtotalWithoutAutoGifts(cart);
        var rules = eligibleRules(subtotalCents);
        var wanted = wantedGifts(rules);
        var operations = Promise.resolve();
        var items = cart.items || [];
        var changed = false;

        items.forEach(function (item) {
          var variantId = itemVariantId(item);
          var wantedGift = wanted[variantId];

          if (!isAutoGift(item)) return;

          if (!wantedGift && config.removeWhenBelowRule !== false) {
            changed = true;
            operations = operations.then(function () {
              diagnose('info', 'Brinde removido porque o carrinho saiu da regra de valor.', {
                reason: reason,
                itemTitle: item.title,
                variantId: variantId,
                subtotalCents: subtotalCents,
              });
              return changeGift(item, 0);
            });
            return;
          }

          if (wantedGift && config.lockGiftQuantity !== false && item.quantity !== wantedGift.quantity) {
            changed = true;
            operations = operations.then(function () {
              diagnose('info', 'Quantidade de brinde ajustada pela regra automatica.', {
                reason: reason,
                itemTitle: item.title,
                variantId: variantId,
                fromQuantity: item.quantity,
                toQuantity: wantedGift.quantity,
              });
              return changeGift(item, wantedGift.quantity);
            });
          }
        });

        Object.keys(wanted).forEach(function (variantId) {
          var alreadyInCart = items.some(function (item) {
            return isAutoGift(item) && itemVariantId(item) === Number(variantId);
          });

          if (alreadyInCart) return;

          changed = true;
          operations = operations.then(function () {
            diagnose('info', 'Brinde adicionado automaticamente por valor de carrinho.', {
              reason: reason,
              gift: wanted[variantId],
              subtotalCents: subtotalCents,
            });
            return addGift(wanted[variantId]);
          });
        });

        return operations.then(function () {
          if (!changed) return null;
          return getCart();
        });
      })
      .then(function (cart) {
        if (cart) refreshCartUi(cart);
      })
      .catch(function (error) {
        diagnose('error', 'Falha ao sincronizar brindes automaticos.', {
          reason: reason,
          error: error && error.message ? error.message : String(error),
          likelyCause: 'A chamada de carrinho foi bloqueada, recusada pela Shopify ou conflitou com outro app.',
        });
      })
      .finally(function () {
        syncing = false;
        if (queuedReason) {
          var nextReason = queuedReason;
          queuedReason = '';
          scheduleSync(nextReason);
        }
      });
  }

  function scheduleSync(reason) {
    window.clearTimeout(scheduledTimer);
    scheduledTimer = window.setTimeout(function () {
      syncGifts(reason || 'scheduled');
    }, 450);
  }

  function installListeners() {
    document.addEventListener('pp:gifts-updated', function () {});

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'pp-cart-gifts') return;
        scheduleSync('cartUpdate');
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('input[name="updates[]"]')) {
        scheduleSync('quantityChange');
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('cart-remove-button, product-form')) {
        scheduleSync('cartClick');
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scheduleSync('pageLoad');
      });
    } else {
      scheduleSync('pageLoad');
    }
  }

  if (!normalizeRules().length) {
    diagnose('info', 'Script de brindes carregado, mas nenhuma regra esta ativa ainda.', {
      howToFix: 'Abra snippets/pp-cart-gifts-config.liquid, coloque variantId do brinde e troque active para true.',
    });
    return;
  }

  installListeners();
})();
